document.addEventListener("DOMContentLoaded", () => {
  const questions = document.querySelectorAll(".ts-faq__question");

  questions.forEach((question) => {
    question.addEventListener("click", () => {
      const answer = question.nextElementSibling;
      const isOpen = answer.classList.contains("open");

      document.querySelectorAll(".ts-faq__answer").forEach((el) => {
        el.classList.remove("open");
        el.style.maxHeight = null;
      });

      document.querySelectorAll(".ts-faq__question").forEach((el) => {
        el.classList.remove("active");
      });

      if (!isOpen) {
        answer.classList.add("open");
        question.classList.add("active");
        answer.style.maxHeight = answer.scrollHeight + "px";
      }
    });
  });
});